import { auth } from './auth';
import { ui } from './ui';

export const atoms = {
  auth,
  ui,
};
